import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/13_waterfall/13_waterfall"
 * Contains 1 texture(s)
 */
export class Tablet13WaterfallAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/13_waterfall/13_waterfall';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '13_waterfall.jpg'
    ] as const;
}
